import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls window to top on every route change UNLESS the URL has a hash
// anchor (e.g. /#contact) — in that case let the anchor handle the scroll.
const ScrollToTop = () => {
  const { pathname, hash, search } = useLocation();

  useEffect(() => {
    if (hash) {
      // Defer to allow the target section to mount, then scroll into view
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        setTimeout(
          () => el.scrollIntoView({ behavior: "smooth", block: "start" }),
          80
        );
        return;
      }
    }
    // Double rAF ensures we scroll AFTER the new route's layout is committed,
    // avoiding sub-pixel offsets caused by images/fonts settling in.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "instant" });
      });
    });
  }, [pathname, hash, search]);

  return null;
};

export default ScrollToTop;
